import Breadcrumb from '@components/breadcrumb/Breadcrumb';
import { profileBreadcrumb } from '@constants/breadcrumbItems';
import Title from 'lib/src/components/typography/Title';
import useFetchProfile from './hooks/useFetchProfile';
import DataCheck from 'lib/src/components/common/DataCheck';
import ProfileInner from './ProfileInner';
import { isEmpty } from 'lib/src/utils/generic';
import { useParams } from 'react-router-dom';
import useProfileSuccessModal from './hooks/useProfileSuccessModal';
import Modal from '@components/modal/Modal';
import ButtonRow from 'lib/src/components/button/ButtonRow';
import ActionButton from 'lib/src/components/button/ActionButton';

const Profile: React.FC = () => {
    const { action } = useParams<ParamTypes>();
    const { profile, isFetching, fetchError } = useFetchProfile();

    const { showSuccessModal, setShowSuccessModal } = useProfileSuccessModal();

    return (
        <>
            <Breadcrumb items={profileBreadcrumb} title="My Profile" />
            <Title>My Profile</Title>
            <DataCheck
                dataExists={!isEmpty(profile) && !isFetching}
                isFetching={isFetching}
                error={fetchError}
            >
                {profile && <ProfileInner profile={profile} action={action} />}
            </DataCheck>

            {!!showSuccessModal && (
                <Modal
                    title={
                        showSuccessModal === 'password' ? 'Password updated' : 'MFA setup complete'
                    }
                    closeModal={() => setShowSuccessModal(null)}
                >
                    {showSuccessModal === 'password' ? (
                        <div className="wysiwyg">
                            <p>Your password has been successfully updated.</p>
                            <ButtonRow alignment="right" className="top-margin">
                                <ActionButton
                                    color="green"
                                    onClick={() => setShowSuccessModal(null)}
                                >
                                    Close
                                </ActionButton>
                            </ButtonRow>
                        </div>
                    ) : (
                        <div className="wysiwyg">
                            <p>Multi-factor authentication has been successfully set up.</p>
                            <ButtonRow alignment="right" className="top-margin">
                                <ActionButton
                                    color="green"
                                    onClick={() => setShowSuccessModal(null)}
                                >
                                    Close
                                </ActionButton>
                            </ButtonRow>
                        </div>
                    )}
                </Modal>
            )}
        </>
    );
};

interface ParamTypes {
    action?: string;
}

export default Profile;
